import SecureNetwork from "../SecureNetwork";

const Success = () => {
  return (
    <>
      <div className="w-full text-center font-bold">
        Dziękujemy za skorzystanie z naszych usług.
      </div>
      <div className="w-full text-center mt-10">
        <h2 className="uppercase text-center">
          Urządzenie zostało pomyślnie uwierzytelnione.
        </h2>
      </div>
      <div className="w-full text-center font-bold">
        <h2 className="uppercase text-center">
          Przejdź na dowolną stronę internetową.
        </h2>
      </div>
      <div className="w-full text-center mt-10">
        <a
          className="rounded bg-blue-500 p-2 text-white font-bold uppercase"
          href={window.config.button.url}
        >
          {window.config.button.text}
        </a>
      </div>
      <SecureNetwork />
    </>
  );
};

export default Success;
